/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Cheapest_PriceInputs */

const en_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheapest price`)
};

const zh_hans1_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低价格`)
};

const pt_br2_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menor preço`)
};

const es_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio más bajo`)
};

const fr_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix le plus bas`)
};

const de_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günstigster Preis`)
};

const ru_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самая низкая цена`)
};

const it_app_endpoint_cheapest_price = /** @type {(inputs: App_Endpoint_Cheapest_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo più basso`)
};

/**
* | output |
* | --- |
* | "Cheapest price" |
*
* @param {App_Endpoint_Cheapest_PriceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_cheapest_price = /** @type {((inputs?: App_Endpoint_Cheapest_PriceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Cheapest_PriceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_cheapest_price(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_cheapest_price(inputs)
	if (locale === "es") return es_app_endpoint_cheapest_price(inputs)
	if (locale === "fr") return fr_app_endpoint_cheapest_price(inputs)
	if (locale === "de") return de_app_endpoint_cheapest_price(inputs)
	if (locale === "ru") return ru_app_endpoint_cheapest_price(inputs)
	if (locale === "it") return it_app_endpoint_cheapest_price(inputs)
	return en_app_endpoint_cheapest_price(inputs)
});